import { StyledImage } from '../../Atoms/Image/styles'
import { StyledTextarea } from '../../Atoms/Textarea/styles'
import { styled } from '../../Styles/stitches.config'

export const StyledFeedback = styled('div', {
    justifyItems: 'start',
    display: 'grid',
    gap: '$3',

    [`& ${StyledTextarea}`]: {
        boxSizing: 'border-box',
    },

    [`& ${StyledImage}`]: {
        maxSize: 20,
    },
})
